import FJUtil from '../../util/FJUtil';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJActionModal from './FJActionModal';
import FJConstant from '../../constants/FJConstant';
import FJImageStore from '../../store/FJImageStore';
import {
    setSliceFreeNumCreationAction,
    setSliceCreationListAction,
    setSliceHistoryListAction,
    setSliceCreditNumberAction,
    setSliceSelectListAction,
    setSliceIsProjectLoadingAction,
    setSliceTaskStatusAction,
    setSliceProgressAction,
    setSliceCurrentQueueAction,
    setSliceQueueNumberAction,
    setSliceBatchDownloadLoadingAction,
    setSliceHistoryListLoadStatusAction,
    setSliceHeaderTabIndexAction,
    setSliceIsLogin,
    setSelectedDownloadList,
    setSliceIsMultipleMode,
    setSliceDefaultFreeLimitInfo,
} from '../slices/FJSliceCommon';
import FJConfig from '../../config/FJConfig';
import { MAX_POLLING_ERROR_TIME, TASK_POLLING_INTERVAL } from '../../config/dataConfig/FJGenerateData';
import FJActionImageToImage from './FJActionImageToImage';
import FJActionImageManipulation from './FJActionImageManipulation';
import FJAppConstant from '../../constants/FJAppConstant';
import FJActionObjectErase from './FJActionObjectErase';
import FJActionPhotoBgRemover from './FJActionPhotoBgRemover';
import { setSliceAutoBackgroundRemoveFreeNum, setSliceBackgroundRemoveFreeNum } from '../slices/FJSlicePhotoBgRemover';
import FJActionFake3d from './FJActionFake3d';
import FJActionAIVideoGenerator from './FJActionAIVideoGenerator.js';
import FJActionImageEnhancer from './FJActionImageEnhancer';
import FJActionAIAudioGenerator from './FJActionAIAudioGenerator.js';
import FJActionVideoRemoveBg from './FJActionVideoRemoveBg.js';
import {
    setSliceVideoAutoBackgroundRemoveFreeNum,
    setSliceVideoBackgroundRemoveFreeNum,
} from '../slices/FJSliceVideoBgRemover.js';
import FJActionVoiceCloning from './FJActionVoiceCloning.js';
import FJTextBasedEditingConfig from '../../config/appConfig/FJTextBasedEditingConfig.js';
import { setHighLightFreeNum } from '../slices/FJTextBasedEditing.jsx';
import FJActionTextToVideo from './FJActionTextToVideo.js';
import FJActionTextToSpeech from './FJActionTextToSpeech.js';
import FJActionTextToSpeechProject from './FJActionTextToSpeechProject.js';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJActionFaceSwap from './FJActionFaceSwap.js';
import FJActionWatermarkRemover from './FJActionWatermarkRemover.js';
import FJActionAIPhotoEditor from './FJActionAIPhotoEditor.js';
import FJActionHairstyleChanger from './FJActionHairstyleChanger.js';
import FJActionAiVideoDub from './FJActionAiVideoDub.js';
import FJActionTextBasedEditing from './textBasedEditing/FJActionTextBasedEditing.js';
import FJActionHeadshotGenerator from './FJActionHeadshotGenerator.js';
import FJActionEditPage from './FJActionEditPage.js';
import FJActionAIPhotoGenerator from './FJActionAIPhotoGenerator.js';
import FJCommunityStore from '../../store/FJCommunityStore.js';
import FJActionTextToImage from './FJActionTextToImage.js';
import { useSelector } from 'react-redux';
import { AI_GENERATOR_PHOTO_TAB_LIST } from '../../config/dataConfig/FJAIPhotoGeneratorData.js';
import FJActionCommunity from './FJActionCommunity.js';

let _eventIdList = [];

const _getPollingTime = appType => {
    if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
        return 1000 * 10;
    }
    if (appType === FJAppConstant.AI_VIDEO_DUB) {
        return 1000 * 4;
    }

    if (appType === FJAppConstant.CLOTHES_CHANGER) {
        return 1000 * 5;
    }

    if (appType === FJAppConstant.HEADSHOT_GENERATOR) {
        return 1000 * 10;
    }

    return TASK_POLLING_INTERVAL;
};

const FJActionCommon = {
    multiDownloadAction: function (ids, source, callback, options = {}) {
        const { headshotIds, appType: tempAppType, previewList: tempPreviewList } = options; // 头像生成任务下载时，过滤内部任务
        return async (dispatch, getState) => {
            if (!ids.length) return;
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai tool download click', { source, tool });
            const { historyList: reducerHistoryList, appType: reducerAppType } = getState().common;
            const appType = tempAppType || reducerAppType;
            const historyList = tempPreviewList || reducerHistoryList;

            const isVideo =
                appType === FJAppConstant.AI_VIDEO_GENERATOR ||
                appType === FJAppConstant.VIDEO_REMOVE_BG ||
                appType === FJAppConstant.AI_VIDEO_DUB;
            const isAudioGenerator = appType === FJAppConstant.AI_AUDIO_GENERATOR;
            const isVideoGeneration = appType === FJAppConstant.AI_VIDEO_GENERATOR;
            const isSpeech = appType === FJAppConstant.TEXT_TO_SPEECH;
            const isHeadshotGenerator = appType === FJAppConstant.HEADSHOT_GENERATOR;

            let downloadHistoryList = historyList.filter(item =>
                // 视频生成和音频生成任务下载时， 需要判断任务是否完成
                isAudioGenerator || isVideoGeneration
                    ? ids.includes(item.id) && item.status === 'completed'
                    : ids.includes(item.id),
            );

            // 如果下载的是text to image，ultra 模型全部任务没有完成时已完成任务无法点击下载。因为历史记录没有更新 从编辑记录拿数据
            if (appType === FJAppConstant.TEXT_TO_IMAGE && downloadHistoryList.length === 0) {
                const creationList = getState().common.creationList;
                downloadHistoryList = creationList.filter(item => ids.includes(item.id));
            }

            if (isHeadshotGenerator) {
                let newDownloadHistoryList = [];
                downloadHistoryList.map(item => {
                    // 如果 headshotIds 不为空，则过滤 headshotList, 否则默认下载全部 headshotList images
                    const successHeadshotList = item.headshotList.filter(item => item.status === 'succeeded');
                    if (headshotIds?.length > 0) {
                        const headshotList = successHeadshotList.filter(item => headshotIds.includes(item.id));
                        newDownloadHistoryList.push(...(headshotList.length > 0 ? headshotList : []));
                    } else {
                        newDownloadHistoryList.push(...successHeadshotList);
                    }
                    return item;
                });
                downloadHistoryList = newDownloadHistoryList;
            }

            const urls = downloadHistoryList.map(item =>
                isVideo ? item.videoUrl : isAudioGenerator ? item.audioUrl : item.imgUrl,
            );

            if (urls.length === 0) {
                FJMessageStore.addMessage(
                    isVideo
                        ? FJLocalStore._('unable-to-perform-this-operation-video')
                        : isSpeech
                          ? FJLocalStore._('failed-to-download-please-try-again')
                          : FJLocalStore._('unable-to-perform-this-operation'),
                    'error',
                );
                callback && callback(false);
                return;
            }
            const isBatch = source === 'multiple choose';
            const isMObile = FJUtil.isMobile();
            if (isBatch) {
                if (isMObile) {
                    dispatch(FJActionModal.showGlobalLoadingAction());
                } else {
                    dispatch(setSliceBatchDownloadLoadingAction(true));
                }
            }
            await FJUtil.multiDownloadByUrls(urls, callback, {
                isVideo: isVideo,
                isAudioGenerator: isAudioGenerator,
                downloadHistoryList,
                isWebm: appType === FJAppConstant.VIDEO_REMOVE_BG,
            });
            if (isBatch) {
                if (isMObile) {
                    dispatch(FJActionModal.hideGlobalLoadingAction());
                } else {
                    dispatch(setSliceBatchDownloadLoadingAction(false));
                }
            }
        };
    },

    multiDeleteAction: function (ids, callback, options = {}) {
        return async (dispatch, getState) => {
            const { selectList, creationList, historyList, appType } = getState().common;

            const isVideo =
                FJConfig.appType === FJAppConstant.AI_VIDEO_GENERATOR ||
                FJConfig.appType === FJAppConstant.VIDEO_REMOVE_BG ||
                FJConfig.appType === FJAppConstant.AI_VIDEO_DUB;
            const isAudioGenerator = FJUtil.isAudioGenerator();
            const { type, headshotIds } = options; // 头像生成任务删除时，过滤内部任务

            const _getDelTitle = () => {
                if (type === FJConstant.CLONE_VOICE) {
                    return FJLocalStore._('delete-voice');
                } else if (type === FJConstant.TEXT_TO_SPEECH) {
                    return FJLocalStore._('delete-project');
                }
                if (isVideo) {
                    return FJLocalStore._('delete-video');
                } else if (isAudioGenerator) {
                    return FJLocalStore._('delete-music');
                }
                return FJLocalStore._('delete-image');
            };

            const _getDelContent = () => {
                if (type === FJConstant.CLONE_VOICE) {
                    return ids.length < 2
                        ? FJLocalStore._(
                              'voice-will-be-deleted-and-cannot-be-restored-are-you-sure-to-continue',
                          ).replace('xx', ids.length)
                        : FJLocalStore._(
                              'voices-will-be-deleted-and-cannot-be-restored-are-you-sure-to-continue',
                          ).replace('xx', ids.length);
                } else if (type === FJConstant.TEXT_TO_SPEECH) {
                    return ids.length < 2
                        ? FJLocalStore._(
                              'project-will-be-deleted-and-cannot-be-restored-are-you-sure-to-continue',
                          ).replace('xx', ids.length)
                        : FJLocalStore._(
                              'projects-will-be-deleted-and-cannot-be-restored-are-you-sure-to-continue',
                          ).replace('xx', ids.length);
                } else if (type === FJAppConstant.HEADSHOT_GENERATOR) {
                    return headshotIds?.length > 0
                        ? headshotIds.length < 2
                            ? FJLocalStore._('xx-image-will-be-deleted-and-cannot-be-restored').replace(
                                  'xx',
                                  headshotIds.length,
                              )
                            : FJLocalStore._('xx-images-will-be-deleted-and-cannot-be-restored').replace(
                                  'xx',
                                  headshotIds.length,
                              )
                        : ids.length < 2
                          ? FJLocalStore._(
                                'project-will-be-deleted-and-cannot-be-restored-are-you-sure-to-continue',
                            ).replace('xx', ids.length)
                          : FJLocalStore._(
                                'projects-will-be-deleted-and-cannot-be-restored-are-you-sure-to-continue',
                            ).replace('xx', ids.length);
                }
                if (isVideo) {
                    return ids.length > 1
                        ? FJLocalStore._('videos-will-be-deleted').replace('xx', ids.length)
                        : FJLocalStore._('video-will-be-deleted').replace('xx', ids.length);
                } else if (isAudioGenerator) {
                    return FJLocalStore._('music-will-be-deleted').replace('xx', ids.length);
                } else {
                    return ids.length > 1
                        ? FJLocalStore._('xx-images-will-be-deleted-and-cannot-be-restored').replace('xx', ids.length)
                        : FJLocalStore._('xx-image-will-be-deleted-and-cannot-be-restored').replace('xx', ids.length);
                }
            };

            const title = _getDelTitle();
            const content = _getDelContent();

            const __delete = async () => {
                const __error = () => {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-please-try-again'), 'error');
                    callback && callback(false);
                };
                try {
                    if (type === FJConstant.TEXT_TO_SPEECH) {
                        dispatch(FJActionTextToSpeechProject.deleteProjectAction(ids));
                    } else if (type === FJAppConstant.HEADSHOT_GENERATOR) {
                        dispatch(FJActionHeadshotGenerator.onDeleteHeadshotAction(ids, callback, options));
                    } else {
                        const result = await FJNetworkStore.deleteTaskList(ids);
                        const { code } = result;
                        if (code === 200) {
                            dispatch(FJActionEditPage.updateAIToolListFromAIToolAction());

                            const newSelectList = selectList.filter(i => !ids.includes(i));
                            dispatch(setSliceSelectListAction(newSelectList));
                            if (appType === FJAppConstant.AI_COMMUNITY) {
                                dispatch(FJActionCommunity._updateDeleteListAction(ids));
                                callback && callback(ids);
                            } else if (isAudioGenerator) {
                                dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(newSelectList.length > 0));
                                dispatch(FJActionAIAudioGenerator.updateHistoryListAction({ callback }));
                            } else if (
                                [
                                    FJAppConstant.TEXT_TO_IMAGE,
                                    FJAppConstant.IMAGE_TO_IMAGE,
                                    FJAppConstant.AI_PHOTO_EDITOR,
                                ].includes(appType)
                            ) {
                                const nowList = historyList.filter(i => !ids.includes(i.id));
                                dispatch(setSliceHistoryListAction(nowList));
                                callback && callback(nowList);
                                dispatch(FJActionCommon.setIsMultipleModeAction(newSelectList.length > 0));
                            } else {
                                dispatch(FJActionCommon.updateHistoryListAction(callback));
                                dispatch(FJActionCommon.setIsMultipleModeAction(newSelectList.length > 0));
                            }
                            if (type === FJConstant.CLONE_VOICE) {
                                dispatch(FJActionTextToSpeech.deleteRecentUsedVoiceListAction(ids));
                            }
                            // 当删除历史时也要过滤掉创作区数据

                            dispatch(this.dealCreationListByDeleteAction(ids));
                        } else if (code === 214) {
                            FJUtil.login();
                        } else {
                            __error();
                        }
                    }
                } catch (e) {
                    __error();
                }
            };
            dispatch(
                FJActionModal.showWarningModalAction({
                    title: title,
                    content: content,
                    footerDates: [
                        {
                            btnType: FJConstant.WARNING,
                            btnText: FJLocalStore._('delete'),
                            btnCallback: async () => {
                                __delete();
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: null,
                        },
                    ],
                }),
            );
        };
    },
    updateHistoryListAction: function (callback, options = {}) {
        return async (dispatch, getState) => {
            const { ignoreLoading = false, ignoreLength = false, ignoreCloneStatus = false } = options;
            const appType = getState().common.appType;
            if (
                appType === FJAppConstant.TEXT_TO_FULL_VIDEO ||
                appType === FJAppConstant.BLOG_URL_TO_VIDEO ||
                appType === FJAppConstant.PRODUCT_URL_TO_VIDEO ||
                appType === FJAppConstant.PPT_TO_VIDEO
            ) {
                return;
            }
            if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
                dispatch(FJActionAIAudioGenerator.updateHistoryListAction());
                return;
            }
            if (
                appType === FJAppConstant.TEXT_TO_IMAGE ||
                appType === FJAppConstant.IMAGE_TO_IMAGE ||
                appType === FJAppConstant.AI_PHOTO_EDITOR
            ) {
                dispatch(FJActionAIPhotoGenerator.updateHistoryListAction({ page: 1, callback: callback }));
                return;
            }

            !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.LOADING));
            try {
                const list = await FJNetworkStore.getTaskList(FJConfig.historyListType);
                if (list && list.length) {
                    const historyList = await FJUtil.parseList(list, { type: FJConstant.HISTORY });
                    const oldHistoryList = getState().common.historyList;
                    if (JSON.stringify(oldHistoryList) !== JSON.stringify(historyList)) {
                        dispatch(setSliceHistoryListAction(historyList));
                    }
                    callback && callback(historyList);
                } else {
                    dispatch(setSliceHistoryListAction([]));
                    callback && callback([]);
                }
                if (getState().common.appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                    dispatch(FJActionAIVideoGenerator.checkIsShowGeneratingVideoNumAction());
                } else if (getState().common.appType === FJAppConstant.HEADSHOT_GENERATOR) {
                    dispatch(FJActionHeadshotGenerator.checkIsShowGeneratingHeadshotNumAction());
                } else if (getState().common.appType === FJAppConstant.TEXT_TO_SPEECH) {
                    dispatch(
                        FJActionVoiceCloning.updateVoiceCloneAction(list && list.length, {
                            ignoreLength,
                            ignoreCloneStatus,
                        }),
                    );
                }
            } catch (error) {
                console.log(error);
            } finally {
                !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.SUCCESS));
            }
        };
    },

    /**
     * @description 更新工具的默认免费次数
     * @returns {(function(*, *): Promise<*>)|*}
     */
    updateDefaultUseFreeLimitAction: function () {
        return async dispatch => {
            try {
                const info = await FJNetworkStore.getUseDefaultFreeLimit();
                if (!info) return;
                dispatch(setSliceDefaultFreeLimitInfo(info));
            } catch (e) {
                console.error(e);
            }
        };
    },

    updateUseFreeLimitAction: function (callback) {
        return async (dispatch, getState) => {
            let freeNum = 0;

            let autoBackgroundRemoveFreeNum = 0;
            let backgroundRemoveFreeNum = 0;

            let videoBackgroundRemoveFreeNum = 0;
            let videoAutoBackgroundRemoveFreeNum = 0;
            try {
                const info = await FJNetworkStore.getUseFreeLimit();
                if (!info) return;
                const appType = getState().common.appType;
                if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                    dispatch(FJActionAIVideoGenerator.updateUseFreeLimitAction(info));
                } else if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
                    dispatch(FJActionAIAudioGenerator.updateUseFreeLimitAction(info));
                } else if (appType === FJAppConstant.OBJECT_ERASER) {
                    dispatch(FJActionObjectErase.updateUseFreeLimitAction(info));
                    // setSliceFreeNumCreationAction 的更新在 ObjectErase 中控制
                    return;
                }
                freeNum = info[FJConfig.freeLimitType];

                if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
                    autoBackgroundRemoveFreeNum = info[FJConfig.autoFreeLimitType];
                    backgroundRemoveFreeNum = info[FJConfig.freeLimitType];

                    dispatch(setSliceAutoBackgroundRemoveFreeNum(autoBackgroundRemoveFreeNum));
                    dispatch(setSliceBackgroundRemoveFreeNum(backgroundRemoveFreeNum));
                } else if (appType === FJAppConstant.AI_TEXT_BASED_EDITING) {
                    dispatch(setHighLightFreeNum(info[FJTextBasedEditingConfig.freeLimitHighlightType]));
                } else if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
                    videoBackgroundRemoveFreeNum = info[FJConfig.freeLimitType];
                    videoAutoBackgroundRemoveFreeNum = info[FJConfig.autoRemoverLimitType];
                    dispatch(setSliceVideoBackgroundRemoveFreeNum(videoBackgroundRemoveFreeNum));
                    dispatch(setSliceVideoAutoBackgroundRemoveFreeNum(videoAutoBackgroundRemoveFreeNum));
                }

                if (
                    appType === FJAppConstant.TEXT_TO_FULL_VIDEO ||
                    appType === FJAppConstant.BLOG_URL_TO_VIDEO ||
                    appType === FJAppConstant.PRODUCT_URL_TO_VIDEO ||
                    appType === FJAppConstant.PPT_TO_VIDEO
                ) {
                    dispatch(FJActionTextToVideo.updateUseFreeLimitAction(info));
                }

                if (appType === FJAppConstant.TEXT_TO_SPEECH) {
                    dispatch(FJActionTextToSpeech.updateUseFreeLimitAction(info));
                }

                dispatch(FJActionTextToImage.updateUseFreeLimitAction(info));
                dispatch(FJActionImageToImage.updateUseFreeLimitAction(info));
                dispatch(FJActionAIPhotoEditor.updateUseFreeLimitAction(info));
            } catch (error) {
                // console.log(error);
            } finally {
                dispatch(setSliceFreeNumCreationAction(freeNum));
                callback && callback();
            }
        };
    },
    updateUserCreditsInfoAction: function (updateFreeLimit = false) {
        return async (dispatch, getState) => {
            const { freeNumCreation, appType } = getState().common;
            const isVideoRemoveBg = appType === FJAppConstant.VIDEO_REMOVE_BG;
            const { autoBackgroundRemoveFreeNum, backgroundRemoveFreeNum } = getState().photoBgRemover;
            const { freeNumCreationInfo } = getState().textToVideo;
            //有免费次数就更新，没有就不更新
            const needUpdateFreeLimit =
                updateFreeLimit ||
                freeNumCreation > 0 ||
                (appType === FJAppConstant.PHOTO_REMOVE_BG &&
                    autoBackgroundRemoveFreeNum + backgroundRemoveFreeNum > 0) ||
                (appType === FJAppConstant.TEXT_TO_FULL_VIDEO && freeNumCreationInfo.textToFullVideo > 0) ||
                (appType === FJAppConstant.BLOG_URL_TO_VIDEO && freeNumCreationInfo.blogUrlToVideo > 0) ||
                (appType === FJAppConstant.PRODUCT_URL_TO_VIDEO && freeNumCreationInfo.productUrlToVideo > 0) ||
                (appType === FJAppConstant.PPT_TO_VIDEO && freeNumCreationInfo.pptToVideo > 0);
            if (needUpdateFreeLimit) {
                await dispatch(FJActionCommon.updateUseFreeLimitAction());
            }
            await dispatch(FJActionCommon.updateCreditsInfo());
            getState().modals.upgradeModalData.display && dispatch(FJActionModal.hideUpgradeModalAction());
            isVideoRemoveBg && dispatch(FJActionVideoRemoveBg.updateGetCreditsAfterRemoveAllAction());
        };
    },
    initProjectInfoAction: function () {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;
            if (appType === FJAppConstant.AI_COMMUNITY) {
                return;
            }
            dispatch(setSliceIsProjectLoadingAction(true));
            let projectLoadingCount = 0;

            const __func = async () => {
                dispatch(setSliceIsProjectLoadingAction(false));

                if (FJConfig.appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                    if (window.isEditPage && window.aiToolInitDone) {
                        await dispatch(FJActionAIVideoGenerator.initAIVideoGeneratorAction());
                    } else {
                        dispatch(FJActionAIVideoGenerator.initAIVideoGeneratorAction());
                    }
                }

                if (window.isEditPage && window.aiToolInitDone) window.aiToolInitDone();
            };
            const __projectLoadingCallback = () => {
                projectLoadingCount++;
                if (projectLoadingCount === 2) {
                    __func();
                }
            };
            dispatch(this.dealCreationListAction([], appType));
            FJImageStore.initWatermarkCanvas();
            dispatch(setSliceIsLogin(FJUtil.isLogin()));

            // 更新默认免费额度
            dispatch(FJActionCommon.updateDefaultUseFreeLimitAction());

            if (FJUtil.isLogin()) {
                if (FJConfig.appType === FJAppConstant.AI_AUDIO_GENERATOR) {
                    dispatch(FJActionAIAudioGenerator.updateHistoryListAction());
                } else if (FJConfig.appType === FJAppConstant.TEXT_TO_SPEECH) {
                    dispatch(FJActionTextToSpeech.getFavoriteAction());
                    dispatch(FJActionTextToSpeechProject.getProjectList());
                    dispatch(
                        FJActionCommon.updateHistoryListAction(undefined, {
                            ignoreCloneStatus: getState().voiceCloning.createCloneStatus === FJConstant.SETTING,
                        }),
                    );
                } else {
                    dispatch(FJActionCommon.updateHistoryListAction());
                }
                dispatch(FJActionCommon.updateCreditsInfo(__projectLoadingCallback));
                dispatch(FJActionCommon.updateUseFreeLimitAction(__projectLoadingCallback));
            } else {
                __func();
            }
        };
    },
    updateCreditsInfo: function (callback) {
        return async dispatch => {
            try {
                const data = await FJNetworkStore.getCreditsInfo();
                if (data) {
                    dispatch(setSliceCreditNumberAction(data.total));
                    if (window.isEditPage && window.EDIT_PAGE_API) {
                        window.EDIT_PAGE_API.updateCredit(data.total);
                    }
                }
            } catch (e) {
                // console.log(e);
            } finally {
                callback && callback();
            }
        };
    },

    dealTaskStatusAction: function (value, appType) {
        return dispatch => {
            switch (appType) {
                case FJAppConstant.TEXT_TO_IMAGE:
                    dispatch(FJActionTextToImage.setTaskStatusAction(value));
                    break;
                case FJAppConstant.IMAGE_TO_IMAGE:
                    dispatch(FJActionImageToImage.setTaskStatusAction(value));
                    break;
                case FJAppConstant.AI_PHOTO_EDITOR:
                    dispatch(FJActionAIPhotoEditor.setTaskStatusAction(value));
                    break;
                default:
                    dispatch(setSliceTaskStatusAction(value));
            }
        };
    },

    dealCreationListByDeleteAction: function (ids) {
        return (dispatch, getState) => {
            const { creationList } = getState().common;
            const { creationList: aiPhotoEditorCreationList } = getState().aiPhotoEditor;
            const { creationList: textToImageCreationList } = getState().textToImage;
            const { creationList: imageToImageCreationList } = getState().imageToImage;

            const __func = (creationList, appType) => {
                if (creationList.length >= 0) {
                    const newCreationList = creationList.filter(creationItem => !ids.includes(creationItem.id));
                    dispatch(this.dealCreationListAction(newCreationList, appType));
                }
            };

            __func(creationList);
            __func(aiPhotoEditorCreationList, FJAppConstant.AI_PHOTO_EDITOR);
            __func(textToImageCreationList, FJAppConstant.TEXT_TO_IMAGE);
            __func(imageToImageCreationList, FJAppConstant.IMAGE_TO_IMAGE);
        };
    },

    dealPollingCreationListAction: function (list, appType) {
        return (dispatch, getState) => {
            switch (appType) {
                case FJAppConstant.TEXT_TO_IMAGE: {
                    const { creationList: curCreationList } = getState().textToImage;
                    let newCreationList = [...list, ...curCreationList.slice(list)];
                    dispatch(FJActionTextToImage.setCreationListAction(newCreationList));
                    break;
                }
                case FJAppConstant.IMAGE_TO_IMAGE: {
                    const { creationList: curCreationList } = getState().imageToImage;
                    let newCreationList = [...list, ...curCreationList.slice(list)];
                    dispatch(FJActionImageToImage.setCreationListAction(newCreationList));
                    break;
                }

                case FJAppConstant.AI_PHOTO_EDITOR: {
                    const { creationList: curCreationList } = getState().aiPhotoEditor;
                    let newCreationList = [...list, ...curCreationList.slice(list)];
                    dispatch(FJActionAIPhotoEditor.setCreationListAction(newCreationList));
                    break;
                }
                default:
                    dispatch(setSliceCreationListAction(list));
            }
        };
    },

    dealCreationListAction: function (list, appType) {
        return dispatch => {
            switch (appType) {
                case FJAppConstant.TEXT_TO_IMAGE: {
                    dispatch(FJActionTextToImage.setCreationListAction(list));
                    break;
                }
                case FJAppConstant.IMAGE_TO_IMAGE: {
                    dispatch(FJActionImageToImage.setCreationListAction(list));
                    break;
                }
                case FJAppConstant.AI_PHOTO_EDITOR: {
                    dispatch(FJActionAIPhotoEditor.setCreationListAction(list));
                    break;
                }
                default:
                    dispatch(setSliceCreationListAction(list));
            }
        };
    },

    /**
     * @desc 轮询任务状态
     * @param {*} eventIdList
     * @param {*} options
     * @returns
     */
    pollingTaskAction(eventIdList, options) {
        // autoDefaultTaskStatus 成功后是否自动回到 default 状态
        const {
            callback,
            progressNumber = 1,
            autoDefaultTaskStatus = true,
            isUseFree = false,
            ignoreCloneStatus = false,
            cusUpdateTaskStatus,
            cusUpdateCreationList,
            appType: paramAppType,
        } = options;
        let timer = null;
        let errorTime = 0;
        let quantityCompletion = 0;
        let preProgress = 0;
        let waitingEndTime = null;

        let finishTaskCount = 0;
        let failTaskCount = 0;
        let allTaskCount = eventIdList.length;
        const finishTaskCreationList = [];

        return async (dispatch, getState) => {
            const appType = paramAppType || getState().common.appType;
            const pollingTime = _getPollingTime(appType);

            //初始化状态
            dispatch(setSliceCurrentQueueAction(0));
            dispatch(setSliceQueueNumberAction(0));
            dispatch(setSliceProgressAction(0));

            const __updateTaskStatus = type => {
                cusUpdateTaskStatus ? cusUpdateTaskStatus(type) : dispatch(this.dealTaskStatusAction(type, appType));
            };

            const __updateCreationList = creationList => {
                cusUpdateCreationList
                    ? cusUpdateCreationList(creationList)
                    : dispatch(this.dealCreationListAction(creationList, appType));
            };

            const _clear = () => {
                clearTimeout(timer);
                timer = null;
            };

            const _request = async eventIdList => {
                try {
                    const result = await FJNetworkStore.getTaskState(eventIdList.join(','));
                    let isStopPolling = false;
                    let data = result;

                    if (!data) {
                        errorTime++;
                        if (errorTime >= MAX_POLLING_ERROR_TIME) {
                            callback({ waitingEndTime, type: FJConstant.ERROR });
                            isStopPolling = true;
                        } else {
                            timer = setTimeout(_request.bind(null, eventIdList), pollingTime);
                        }
                        return;
                    }

                    if (!Array.isArray(result)) {
                        // 处理数组类型的data
                        data = [result];
                    }

                    let allTaskStatus = '';
                    let errorMessage = '';
                    let errorCode = '';
                    let queue = {};
                    let progress = 0;
                    const curEventIdList = [...eventIdList];
                    await Promise.all(
                        data.map(async item => {
                            if (item.soft_canceled) {
                                allTaskStatus = 'canceled';
                            } else {
                                switch (item.job_state) {
                                    case 'succeeded':
                                        dispatch(FJActionEditPage.updateAIToolListFromAIToolAction());

                                        if (item.out_put) {
                                            const list = item.out_put.map(inner => {
                                                return {
                                                    ...inner,
                                                    job_type: item.job_type,
                                                };
                                            });

                                            const creationList = await FJUtil.parseList(list, {
                                                type: FJConstant.CREATIONS,
                                                isUploadWaterMark:
                                                    getState().common.appType !== FJAppConstant.FACE_SWAP,
                                            });
                                            finishTaskCreationList.push(...creationList);
                                        } else {
                                            failTaskCount++;
                                        }
                                        curEventIdList.splice(curEventIdList.indexOf(item.event_id), 1);
                                        finishTaskCount++;
                                        break;
                                    case 'waiting':
                                        (allTaskStatus === '' ||
                                            allTaskStatus === 'processing' ||
                                            allTaskStatus === 'canceled') &&
                                            (allTaskStatus = 'waiting');

                                        if (item.queue) {
                                            queue = item.queue;
                                        }
                                        break;
                                    case 'processing':
                                        allTaskStatus === '' && (allTaskStatus = 'processing');
                                        if (item.progress) {
                                            progress = item.progress;
                                        }
                                        break;
                                    case 'canceled':
                                        allTaskStatus = 'canceled';
                                        break;
                                    case 'timeout':
                                    case 'failed':
                                        failTaskCount++;
                                        finishTaskCount++;
                                        errorMessage = item.error_msg;
                                        errorCode = item.error_code;
                                        curEventIdList.splice(curEventIdList.indexOf(item.event_id), 1);
                                        if (failTaskCount === allTaskCount) {
                                            allTaskStatus = 'failed';
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }),
                    );

                    // 全部任务完成, 并且美元全部失败 则更改状态为成功
                    if (finishTaskCount >= allTaskCount) {
                        allTaskStatus !== 'failed' && (allTaskStatus = 'succeeded');
                    }
                    if (finishTaskCreationList.length > 0) {
                        const finishTaskCreationListLength = finishTaskCreationList.length;
                        let curCreationList = [];
                        switch (appType) {
                            case FJAppConstant.TEXT_TO_IMAGE: {
                                curCreationList = getState().textToImage.creationList;
                                break;
                            }
                            case FJAppConstant.IMAGE_TO_IMAGE: {
                                curCreationList = getState().imageToImage.creationList;
                                break;
                            }
                            case FJAppConstant.AI_PHOTO_EDITOR: {
                                curCreationList = getState().aiPhotoEditor.creationList;
                                break;
                            }
                            default:
                                curCreationList = getState().common.creationList;
                        }

                        let newCreationList = [
                            ...finishTaskCreationList,
                            ...curCreationList.slice(finishTaskCreationListLength),
                        ];
                        //todo:  临时处理  如果有部分失败或隐藏 则过滤掉，只保留有结果
                        // if (finishTaskCount >= allTaskCount) {
                        //     __updateCreationList(finishTaskCreationList);
                        // } else {
                        // }
                        __updateCreationList(newCreationList);
                    }

                    if (allTaskStatus) {
                        switch (allTaskStatus) {
                            case 'succeeded': {
                                __updateTaskStatus(FJConstant.SUCCESS);
                                dispatch(FJActionCommon.updateHistoryListAction(undefined, { ignoreCloneStatus }));
                                const returnData = {
                                    waitingEndTime,
                                    type: FJConstant.SUCCESS,
                                    failTaskCount,
                                    errorCode,
                                };
                                // 视频删除背景需要返回生成成果后的视频
                                callback(
                                    FJConfig.appType === FJAppConstant.VIDEO_REMOVE_BG ||
                                        FJConfig.appType === FJAppConstant.AI_VIDEO_DUB ||
                                        appType === FJAppConstant.TEXT_TO_SPEECH
                                        ? { ...returnData, finishTaskCreationList }
                                        : returnData,
                                );
                                autoDefaultTaskStatus &&
                                    setTimeout(() => {
                                        __updateTaskStatus(FJConstant.DEFAULT);
                                    }, 2000);
                                isStopPolling = true;
                                break;
                            }
                            case 'waiting':
                                __updateTaskStatus(FJConstant.WAITING);
                                break;
                            case 'processing':
                                __updateTaskStatus(FJConstant.GENERATING);
                                !waitingEndTime && (waitingEndTime = new Date().getTime());
                                break;
                            case 'canceled':
                                callback({ waitingEndTime, type: FJConstant.CANCEL });
                                __updateTaskStatus(FJConstant.DEFAULT);
                                FJUtil.updateAllCreditInfo(isUseFree);

                                isStopPolling = true;
                                break;
                            case 'failed':
                                __updateTaskStatus(FJConstant.DEFAULT);
                                callback({
                                    waitingEndTime,
                                    type: FJConstant.ERROR,
                                    failTaskCount,
                                    errorMessage,
                                    errorCode,
                                });
                                isStopPolling = true;
                                FJUtil.updateAllCreditInfo(isUseFree);

                                break;
                            default:
                                break;
                        }
                        //更新排队信息
                        if (queue) {
                            let currentQueue = queue?.current_queue || 0;
                            let queueNumber = queue?.queue_count || 0;
                            dispatch(setSliceCurrentQueueAction(currentQueue));
                            dispatch(setSliceQueueNumberAction(queueNumber));
                        }
                        //更新进度
                        if (progress) {
                            if (progress < preProgress) {
                                quantityCompletion++;
                            }
                            let sliceProgress = Math.round(
                                ((quantityCompletion + progress / 100) / progressNumber) * 100,
                            );
                            dispatch(setSliceProgressAction(sliceProgress));
                            preProgress = progress;
                        }
                        errorTime = 0;
                    }
                    if (isStopPolling) {
                        _clear();
                    } else {
                        timer = setTimeout(_request.bind(null, curEventIdList), pollingTime);
                    }
                } catch (error) {
                    console.log(error);
                    callback({ waitingEndTime, type: FJConstant.ERROR });
                    _clear();
                }
            };
            _eventIdList = [...eventIdList];
            timer = setTimeout(_request.bind(null, eventIdList), pollingTime);
        };
    },

    /**
     * 创建请求任务
     * @param {Function} request 请求函数
     * @param {Function} dispatch 派发函数
     * @returns {Promise<string>} 任务ID
     */
    createRequestTask: async function (request, dispatch) {
        const idInfo = await request();
        const { code, data: dataInfo, msg } = idInfo;
        if (code === 401) {
            dispatch(FJActionModal.showUpgradeModalAction());
            return;
        } else if (code === 214) {
            FJUtil.login();
            return;
        } else if (code === 501) {
            dispatch(FJActionModal.showServerBusyModalAction());
            return;
        } else if (code === 423) {
            // 处理视频生成内容违规报错
            const error = new Error(msg);
            error.cause = code;
            throw error;
        }
        const eventId = dataInfo?.event_id;
        if (!eventId) {
            const error = new Error('create task error');
            error.cause = code;
            throw error;
        }
        return eventId;
    },

    /**
     * @desc 切换右侧界面
     * @param {number} index
     * @returns
     */
    setHeaderTabIndexAction: function (value) {
        return async (dispatch, getState) => {
            value === FJConstant.CREATIONS && dispatch(setSliceSelectListAction([]));
            dispatch(setSliceHeaderTabIndexAction(value));

            if (value === FJConstant.HISTORY && getState().common.appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                dispatch(FJActionAIVideoGenerator.setIsShowGeneratingVideoNumAction(false));
            }
        };
    },

    setSelectListAction: function (list) {
        return (dispatch, getState) => {
            const addMediaLibraryInfo = getState().modals.addMediaLibraryInfo;
            const { visible } = addMediaLibraryInfo;
            if (visible) return;
            dispatch(setSliceSelectListAction(list));
        };
    },

    /**
     * @desc 取消任务
     * @returns
     */
    cancelTaskAction: function (eventList = _eventIdList, autoDefaultData = true) {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;

            switch (appType) {
                case FJAppConstant.IMAGE_TO_IMAGE:
                    dispatch(FJActionImageToImage.cancelTaskAction());
                    break;
                case FJAppConstant.IMAGE_ENHANCER:
                    // 移动端图片增强
                    dispatch(FJActionImageEnhancer.mobileCancelTaskAction());
                    break;
                case FJAppConstant.VIDEO_REMOVE_BG:
                    dispatch(FJActionVideoRemoveBg.cancelExportVideoAction());
                    dispatch(FJActionVideoRemoveBg.autoCancelExportVideoAction());
                    dispatch(FJActionVideoRemoveBg.cancelCustomRemoverAction());
                    dispatch(FJActionVideoRemoveBg.cancelAutoRemoverAction());
                    break;
                case FJAppConstant.AI_TEXT_BASED_EDITING:
                    dispatch(FJActionTextBasedEditing.onCancelAction());
                    break;
                default:
                    try {
                        eventList && eventList.length > 0 && (await FJNetworkStore.cancelTask(_eventIdList.join()));
                    } catch (e) {
                        FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
                    } finally {
                        autoDefaultData && dispatch(this.dealCreationListAction([], appType));
                        autoDefaultData && dispatch(this.dealTaskStatusAction(FJConstant.DEFAULT, appType));
                    }
                    break;
            }
        };
    },

    /**
     * @desc 编辑页内打开ai工具关闭时执行
     * @returns
     */
    editCloseAction: function () {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;

            if (!window.isEditPage) return;

            switch (appType) {
                case FJAppConstant.OBJECT_ERASER:
                    dispatch(FJActionObjectErase.editCloseAction());
                    break;
                case FJAppConstant.PHOTO_REMOVE_BG:
                    dispatch(FJActionPhotoBgRemover.editCloseAction());
                    break;
                case FJAppConstant.FACE_SWAP:
                    dispatch(FJActionFaceSwap.editCloseAction());
                    break;
                case FJAppConstant.PHOTO_COLORIZE:
                case FJAppConstant.PHOTO_RESTORATION:
                    dispatch(FJActionImageManipulation.editCloseAction());
                    break;
                case FJAppConstant.AI_PHOTO_EDITOR:
                    dispatch(FJActionAIPhotoEditor.editCloseAction());
                    break;
                case FJAppConstant.WATERMARK_REMOVER:
                    dispatch(FJActionWatermarkRemover.editCloseAction());
                    break;
                case FJAppConstant.AI_HAIRSTYLE_CHANGER:
                    dispatch(FJActionHairstyleChanger.editCloseAction());
                    break;
                case FJAppConstant.AI_VIDEO_DUB:
                    dispatch(FJActionAiVideoDub.editCloseAction());
                    break;
                case FJAppConstant.VIDEO_REMOVE_BG:
                    dispatch(FJActionVideoRemoveBg.editCloseAction());
                    break;
                case FJAppConstant.AI_VIDEO_GENERATOR:
                    dispatch(FJActionAIVideoGenerator.editCloseAction());
                    break;
                case FJAppConstant.AI_TEXT_BASED_EDITING:
                    dispatch(FJActionTextBasedEditing.editCloseAction());
                    break;
                default:
                    break;
            }
        };
    },

    /**
     * @desc 重新生成
     * @param {string} id
     * @returns
     */
    reGenerateAction: function (id) {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;

            switch (appType) {
                case FJAppConstant.IMAGE_TO_IMAGE:
                    dispatch(FJActionImageToImage.reGenerateAction(id));
                    break;
                case FJAppConstant.PHOTO_RESTORATION:
                case FJAppConstant.PHOTO_COLORIZE:
                    dispatch(FJActionImageManipulation.reGenerateAction(id));
                    break;
                case FJAppConstant.OBJECT_ERASER:
                    dispatch(FJActionObjectErase.reGenerateAction(id));
                    break;
                case FJAppConstant.WATERMARK_REMOVER:
                    dispatch(FJActionWatermarkRemover.reGenerateAction(id));
                    break;
                case FJAppConstant.AI_VIDEO_GENERATOR:
                    dispatch(FJActionAIVideoGenerator.retryTaskAction(id));
                    break;
                default:
                    break;
            }
        };
    },

    /**
     * @desc ai 工具生成
     * @returns
     */
    generateAction: function () {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;
            switch (appType) {
                case FJAppConstant.OBJECT_ERASER:
                    dispatch(FJActionObjectErase.generateAction());
                    break;
                case FJAppConstant.PHOTO_REMOVE_BG:
                    dispatch(FJActionPhotoBgRemover.generateAction());
                    break;
                default:
                    break;
            }
        };
    },

    /**
     * @desc 编辑历史
     * @param {Object} data
     * @param {Function} callback
     * @returns
     */
    editHistoryItemAction: function (data, callback, options = {}) {
        return (dispatch, getState) => {
            const appType = getState().common.appType;
            if (appType === FJAppConstant.FAKE_3D) {
                dispatch(FJActionFake3d.editFake3dHistoryAction(data, callback));
            }
            if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
                dispatch(FJActionPhotoBgRemover.editPhotoBgRemoverHistoryAction(data, callback));
            }
            if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
                dispatch(FJActionVideoRemoveBg.editVideoRemoveBgHistoryAction(data, callback, options));
            }
        };
    },
    /**
     * 检查用户空间是否切换
     * @param {*} spaceCheckType
     * @returns
     */
    userSpaceChangeAction: function (spaceCheckType) {
        return dispatch => {
            // 账号混淆的情况
            const abnormalState = [3, 4, 5];
            if (abnormalState.includes(spaceCheckType)) {
                dispatch(FJActionModal.accountChangesModalAction());
            }
        };
    },

    getCreditsAction: function () {
        return async dispatch => {
            if (!FJUtil.isMobile()) {
                const userSpaceType = await FJUtil.checkUserSpace();
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return;
                }
            }
            FJUtil.getCredits();
        };
    },

    setSelectedDownloadItemsAction: function (items) {
        return dispatch => {
            dispatch(setSelectedDownloadList(items));
        };
    },

    // 下载选中的素材
    downloadSelectedItemsAction: function (propsCreationList) {
        return (dispatch, getState) => {
            const appType = getState().common.appType;
            FJUtil.eaLog('ai tool download click', { source: 'creation', tool: FJUtil.getToolName() });

            if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
                dispatch(FJActionPhotoBgRemover.downloadSelectedItemsAction());
            } else {
                const selectedDownloadList = getState().common.selectedDownloadList;
                const { creationList: commonCreationList } = getState().common;
                const creationList = propsCreationList || commonCreationList;
                const { imageEnhancerCreationList } = getState().imageEnhancer;

                const list = appType === FJAppConstant.IMAGE_ENHANCER ? imageEnhancerCreationList : creationList;
                const isVideo = appType === FJAppConstant.AI_VIDEO_DUB;
                const options = {
                    isVideo,
                    errorMessage: isVideo
                        ? FJLocalStore._('unable-to-perform-this-operation-video')
                        : FJLocalStore._('unable-to-perform-this-operation'),
                };
                let downloadList;
                dispatch(setSliceBatchDownloadLoadingAction(true));

                if (list.length > 1) {
                    downloadList = list
                        .filter(item => selectedDownloadList.findIndex(sItem => sItem.id === item.id) !== -1)
                        .map(item => (isVideo ? item.videoUrl : item.imgUrl));
                } else if (list.length === 1) {
                    downloadList = [isVideo ? list[0].videoUrl : list[0].imgUrl];
                }
                FJUtil.multiDownloadByUrls(
                    downloadList,
                    () => {
                        dispatch(setSliceBatchDownloadLoadingAction(false));
                    },
                    options,
                );
            }
        };
    },

    setIsMultipleModeAction: function (bool) {
        return dispatch => {
            dispatch(setSliceIsMultipleMode(bool));
        };
    },

    /**
     * @description 跳转图生视频
     * @returns {(function(*): void)|*}
     */
    imageToVideoAction: function () {
        return (dispatch, getState) => {
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai_image_tool_to_video_generator_click', { tool });

            const creationList = getState().common.creationList;
            const avator = creationList[0]?.imgUrl || '';
            if (!avator) return;
            const recId = `${Date.now()}${Math.random().toString(36).substr(2, 9)}`;
            localStorage.setItem(recId, JSON.stringify({ avator }));
            const toolName = FJUtil.getAIToolHref(AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO);
            const url = FJUtil.getCurrentUrl() + toolName.slice(1) + '?rec_id=' + recId;

            window.open(url, '_blank');
        };
    },

    multiPrivacySettingChangeAction: function (items, value, callback) {
        return async dispatch => {
            if (!FJUtil.isLogin()) {
                FJUtil.login(() => {});
                return;
            }
            const ids = items.filter(item => item?.privacyStatus !== value).map(item => item.id);
            if (ids.length === 0) {
                callback && callback(true);
                return;
            }
            const res = await FJCommunityStore.publishCommunityWork(ids, value);
            if (!res) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-update-privacy-setting'), 'error');
                callback && callback(false);
                return;
            }
            FJMessageStore.addMessage(FJLocalStore._('updated-successfully'));

            dispatch(this.updateHistoryListPrivacySettingAction(ids, value));
            dispatch(this.updateCreationListPrivacySettingAction(ids, value));
            FJUtil.eaLog('community privacy settings', {
                setting: value,
            });
            callback && callback(true);
        };
    },

    updateCreationListPrivacySettingAction: function (ids, value) {
        return (dispatch, getState) => {
            const state = getState();
            const oldAiPhotoEditorCreationList = state.aiPhotoEditor.creationList;
            const oldTextToImageCreationList = state.textToImage.creationList;
            const oldImageToImageCreationList = state.imageToImage.creationList;
            const oldCreationList = state.common.creationList;

            const __getNewList = creationList => {
                return creationList.map(item => {
                    return {
                        ...item,
                        privacyStatus: ids.includes(item.id) ? value : item.privacyStatus,
                    };
                });
            };
            dispatch(FJActionTextToImage.setCreationListAction(__getNewList(oldTextToImageCreationList)));
            dispatch(FJActionAIPhotoEditor.setCreationListAction(__getNewList(oldAiPhotoEditorCreationList)));
            dispatch(FJActionImageToImage.setCreationListAction(__getNewList(oldImageToImageCreationList)));
            dispatch(setSliceCreationListAction(__getNewList(oldCreationList)));
        };
    },

    updateHistoryListPrivacySettingAction: function (ids, value) {
        return (dispatch, getState) => {
            const state = getState();
            const oldHistoryList = state.common.historyList;

            dispatch(
                setSliceHistoryListAction(
                    oldHistoryList.map(item => {
                        return {
                            ...item,
                            privacyStatus: ids.includes(item.id) ? value : item.privacyStatus,
                        };
                    }),
                ),
            );
        };
    },

    /**
     * @description 更新一些数据
     * @param id
     * @param options
     * @returns {(function(*, *): void)|*}
     */
    updateHistoryListCommunityInfoAction: function (id, options = {}) {
        return (dispatch, getState) => {
            const state = getState();
            const oldHistoryList = state.common.historyList;

            dispatch(
                setSliceHistoryListAction(
                    oldHistoryList.map(item => {
                        if (id === item.id) {
                            return {
                                ...item,
                                ...options,
                            };
                        } else {
                            return {
                                ...item,
                            };
                        }
                    }),
                ),
            );
        };
    },

    onRecreateAction: function (data) {
        return dispatch => {
            const { jobType, generationType } = data;
            switch (jobType) {
                case 6:
                    // 6 FJAppConstant.TEXT_TO_IMAGE
                    dispatch(FJActionAIPhotoGenerator.changeTabIndexAction(AI_GENERATOR_PHOTO_TAB_LIST[1], 1));
                    dispatch(FJActionTextToImage.editHistoryItemAction(data));
                    break;
                case 3:
                    dispatch(FJActionAIPhotoGenerator.changeTabIndexAction(AI_GENERATOR_PHOTO_TAB_LIST[0], 0));
                    dispatch(FJActionImageToImage.editHistoryItemAction(data));
                    // 6 FJAppConstant.IMAGE_TO_IMAGE
                    break;
                case 36:
                    dispatch(FJActionAIPhotoGenerator.changeTabIndexAction(AI_GENERATOR_PHOTO_TAB_LIST[2], 2));
                    dispatch(FJActionAIPhotoEditor.editHistoryItemAction(data));
                    // 6 FJAppConstant.AI_PHOTO_EDITOR
                    break;
                case 28:
                    dispatch(
                        FJActionAIVideoGenerator.changeTabIndexAction(AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO),
                    );
                    dispatch(FJActionAIVideoGenerator.editHistoryItemAction(data));
                    break;
                case 14: {
                    if (generationType === 'iv') {
                        dispatch(
                            FJActionAIVideoGenerator.changeTabIndexAction(
                                AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO,
                            ),
                        );
                    } else if (generationType === 'tv') {
                        dispatch(
                            FJActionAIVideoGenerator.changeTabIndexAction(AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO),
                        );
                    }
                    dispatch(FJActionAIVideoGenerator.editHistoryItemAction(data));
                    break;
                }
                default:
                    dispatch(FJActionCommon.editHistoryItemAction(data, null, { position: 'preview' }));
            }
            dispatch(setSliceHeaderTabIndexAction(FJConstant.CREATIONS));
        };
    },
};
export default FJActionCommon;
